import { Tbody } from "@chakra-ui/react"
import { ItemLayout } from "./ItemLayout"

export const ListLayout = ({ layouts }) => {
  return (
    <>
    <Tbody>
      {layouts && layouts.length === 0 && (
        <tr>
          <td colSpan="6" style={{ textAlign: 'center' }}>
            Nenhum layout encontrado
          </td>
        </tr>
      )}
      {layouts?.map((item) => (
        <ItemLayout key={item.id} item={item} />
      ))}
    </Tbody>
    </>
  )
}